import { CHAT_ASSISTANT_PADDING_HORIZONTAL } from '@fruitful/agent-ui';
import { YStack } from 'smoothie';

import { StaticFruitfulIcon } from './StaticFruitfulIcon';

export const AssistantLogoIconFooter = () => {
    return (
        <YStack
            paddingHorizontal={CHAT_ASSISTANT_PADDING_HORIZONTAL}
            paddingBottom={40}
        >
            <StaticFruitfulIcon />
        </YStack>
    );
};
